import React, { Component } from 'react';

class PageNotFound extends Component {
  render() {
    return (
      <section className="page not-found-page">
        <section className="section">
          <div className="content-wrap">
            <article>
              <div className="thumbnail">
                <img
                  width="480"
                  height="572"
                  src="https://www.spot.im/wp-content/uploads/sites/5/2016/05/dog.png"
                  className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                />
              </div>
              <div className="text">
                <h1 className="text-header">Apologies, but nothing exists here.</h1>
                <p className="text-content">
                  You can check out our <a href="https://support.spot.im">Support</a> and{' '}
                  <a href="https://developers.spot.im">Developers</a> sites for help, read our
                  latest <a href="https://blog.spot.im">Blog</a> posts or head back to{' '}
                  <a href="/">Home</a>.
                </p>
              </div>
            </article>
          </div>
        </section>
      </section>
    );
  }
}

PageNotFound.displayName = 'PageNotFound';

export default PageNotFound;
